// extracted by mini-css-extract-plugin
export default {"answer":"styles_answer__ayMHr","selected":"styles_selected__qFmN8"};